import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { api } from "@/lib/api";
import ProductCard from "@/components/ProductCard";

export default function BrandDetail() {
  const { brandSlug } = useParams();
  const [data, setData] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setData(null);
    setNotFound(false);
    api
      .get(`/brands/${brandSlug}`)
      .then(({ data }) => setData(data))
      .catch(() => setNotFound(true));
    window.scrollTo(0, 0);
  }, [brandSlug]);

  if (notFound)
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-4 pt-[68px] lg:pt-[116px]" data-testid="brand-not-found">
        <p className="font-display text-2xl">Brand not found</p>
        <Link to="/brands" className="link-underline font-mono text-sm uppercase">Back to brands</Link>
      </div>
    );

  if (!data) return <div className="min-h-screen animate-pulse bg-black/5 pt-[68px] lg:pt-[116px]" />;

  return (
    <div className="min-h-screen pt-[68px] lg:pt-[116px]" data-testid="brand-detail-page">
      {/* Hero */}
      <section className="border-b border-black/10 bg-gradient-to-br from-[#0A2540] via-[#0A2540] to-[#12365a] py-20 text-white sm:py-28">
        <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
          <Link to="/brands" className="mb-6 inline-flex items-center gap-2 font-mono text-xs uppercase tracking-overline text-white/60 transition-colors hover:text-white" data-testid="back-to-brands">
            <ArrowLeft className="h-3.5 w-3.5" /> All brands
          </Link>
          <p className="font-mono text-xs uppercase tracking-overline text-[#34D8A0]">Physio-Approved Formula House</p>
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            className="mt-4 font-display text-5xl font-black leading-[1.05] tracking-tight sm:text-7xl"
            data-testid="brand-name"
          >
            {data.name}.
          </motion.h1>
          <p className="mt-6 font-mono text-sm text-white/60">{data.count} formula{data.count > 1 ? "s" : ""} in this range</p>
        </div>
      </section>

      {/* Products */}
      <section className="mx-auto max-w-[1400px] px-5 py-16 sm:px-8 sm:py-24">
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {data.products.map((p, i) => (
            <ProductCard key={p.id} product={p} index={i} />
          ))}
        </div>
      </section>
    </div>
  );
}
